module.exports = __webpack_public_path__ + "static/quiz4_question7-b416a43a6fbbe7eed127ea0439847388.jpg";